import React from "react";
import _ from "lodash";
import Icons from "../../constants/Icons";
import StyleUtils from "../../utils/StyleUtils";
import { BLUR } from "../../constants/MergeConstants";

class Icon extends React.PureComponent {
  render() {
    const styleDefaults = {
      width: "100%",
      height: "100%",
      position: "absolute",
      top: 0,
    };

    const content = this.props.content;
    const iconId = content.get("icon", false);
    let view = null;
    const theme = this.props.theme;
    const elemProps = this.props.elemProps;
    const color = StyleUtils.getColorValue(elemProps.get("c", "#fff"), theme);
    const shadowStyle = StyleUtils.getShadowStyle(elemProps, theme, "svg");
    let id = this.props.id;

    const style = { ...styleDefaults, shadowStyle };

    if (iconId) {
      let svg = "";
      if (iconId == "custom") {
        svg = content.get("customSVG", "");
      } else {
        const icon = _.find(Icons.ICON_LIST, ["id", iconId]);
        if (icon) {
          svg = icon.svg;
        }
      }

      const blur = Number(elemProps.getIn(BLUR.split("."), 0) ?? 0);
      let filterStyle = shadowStyle?.filter || "";
      if (blur > 0) {
        filterStyle = filterStyle ? `${filterStyle} blur(${blur}px)` : `blur(${blur}px)`;
      }

      //Create Friendly ID to apply a style to
      id = "svg-" + id.replace(/\./g, "_") + "-" + this.props.layout;
      svg =
        `<style>#${id} svg{fill:${color};${
          filterStyle ? `filter:${filterStyle};` : ""
        }width:100%;height:100%}</style>` + svg;
      view = <div id={id} style={style} dangerouslySetInnerHTML={{ __html: svg }}></div>;
    } else {
      view = <div style={style}></div>;
    }

    return view;
  }
}

export default Icon;
